'use client'

import {isProductViewModelWithVariants} from '@/src/entities/product/helpers/validators'
import * as UI from '@/src/features/catalog/product-list/product-list-item.styled'
import {AttributesModal} from '@/src/features/catalog/product-list/attributes-modal'
import React from 'react'
import {observer} from 'mobx-react'
import {useProductListItem} from '@/src/features/catalog/product-list/product-list-item.provider'

export const ProductAttributesModalContainer = observer(() => {
  const productListItemVM = useProductListItem()
  if (!productListItemVM) throw Error('Product item view model does not found in list')

  return (
    isProductViewModelWithVariants(productListItemVM) && (
      <UI.AttributesModal
        as={AttributesModal}
        key={(productListItemVM.attributes.showModal && '+') || '-'}
        productListItemVM={productListItemVM}
        open={productListItemVM.attributes.showModal}
        setOpen={productListItemVM.showAttributesModal}
      />
    )
  )
})
